import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Container, Header, Segment, Divider } from "semantic-ui-react";
import _t from "../utils/translate";
// import { Helmet } from "react-helmet";

class SignupConfirmation extends React.Component {
  // componentDidMount() {
  //   // Déclencher l'événement de conversion Google Ads lorsque la page est chargée
  //   if (window.gtag) {
  //     window.gtag("event", "conversion", {
  //       send_to: "AW-16632454238/wa9mCPqCwsoZEN64_Po9",
  //     });
  //     console.log("Conversion event sent to Google Ads");
  //   } else {
  //     console.error("Google Ads tracking code (gtag) is not available");
  //   }
  // }

  render() {
    const { language } = this.props;

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          minHeight: "70vh",
        }}
      >      
        <Container text style={{ margin: "auto" }}>
          <Segment padded="very" textAlign="center">
            <Header as="h2">
              {_t(
                "Thank you for signing up. We'll inform you once your account has been activated."
              )}
            </Header>

            <Divider hidden />

            <p>
              {_t(
                "You will receive an email once your account has been verified and activated."
              )}
            </p>

            <Divider hidden />

            <Link to={`/${language}/`}>{_t("Back to Home")}</Link>
          </Segment>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  language: state.ui.language,
});

export default connect(mapStateToProps)(SignupConfirmation);
